import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageLabelFor } from "./Breadcrumbs";
import { formatRemaining, useSessionRemaining } from "./SessionWatcher";

// The browser tab's title, as the clinical OX.ar does it: the page, then the
// product ("Observation results - OX.ar"). The patient's name is deliberately
// not in it: tab titles show in task bars and history.
//
// In the last two minutes before the sign-in runs out, the tab flashes between
// that title and "Signed out in 1:23" so a patient who is in another tab or
// window notices; the countdown prompt on the page itself is the same one
// SessionWatcher shows.

const PRODUCT = "OX.ar · Assisted Reproduction";
const WARN_AT = 120;

export default function TitleManager() {
  const { pathname } = useLocation();
  const remaining = useSessionRemaining();

  useEffect(() => {
    const label = pageLabelFor(pathname);
    const base = label ? `${label} — ${PRODUCT}` : PRODUCT;
    const warning = remaining !== null && remaining > 0 && remaining <= WARN_AT;
    document.title = warning && remaining % 2 === 0
      ? `⚠ Signed out in ${formatRemaining(remaining)} — OX.ar`
      : base;
  }, [pathname, remaining]);

  useEffect(() => () => { document.title = PRODUCT; }, []);
  return null;
}
